module.exports = __webpack_public_path__ + "static/media/3.a1598c9f.jpg";